import React, { useState } from 'react';

import { getImageSrc } from '../../utils';

import Img from '../Img';
import { useSelector } from 'react-redux';
import { getItemComments } from '../../selectors/items';
import TileComments from './TileComments';
import Inventory from './Inventory';
import Orders from './Orders';

export const DEFAULT_TILE_WIDTH = 300;
export const DEFAULT_TILE_HEIGHT = 300;
export const DEFAULT_TILE_PADDING = 5;

const Tile = ({
  item,
  template_color,
  currency_symbol,
  onImageLoad,
  is_shop_free,
  showInventory,
  buyInventory,
  showComments,
  onClick,
  onAddItem,
  onRemoveItem,
  showItemCount,
  useV2 = false,
  hide_pricing = '0',
  width = DEFAULT_TILE_WIDTH,
  height = DEFAULT_TILE_HEIGHT,
  padding = DEFAULT_TILE_PADDING,
  imgSize = 'large',
}) => {
  const itemComments = useSelector(s => getItemComments(s, { item_id: item.item_id }));

  const [isHover, setHover] = useState(false);

  function onMouseEnter(e) {
    setHover(true);
  }

  function onMouseLeave(e) {
    setHover(false);
  }

  if ('OPTION' !== item.parent_type) {
    return null;
  }

  let item_prices = [];
  if (showInventory && !buyInventory && (item.inventory_items ?? []).length > 0) {
    item_prices = item.inventory_items.map(ii => parseFloat(ii.price));
  } else if (item.options && item.options.length) {
    item_prices = item.options.filter(o => 0 == o.hidden && 0 != o.unit_price).map(o => parseFloat(o.unit_price));
  }else if(item.min_price && item.max_price) {
    item_prices = [item.min_price, item.max_price];
  }
  const minimum_price = Math.min.apply(null, item_prices);
  const maximum_price = Math.max.apply(null, item_prices);
  const displayPrice = +hide_pricing !== 1 && item_prices.length
    ? (minimum_price === maximum_price
        ? `${currency_symbol}${minimum_price.toFixed(2)}`
        : `${currency_symbol}${minimum_price.toFixed(2)} - ${currency_symbol}${maximum_price.toFixed(2)}`)
    : null;

  const baseImageStyle = {
    cursor: 'pointer',
    WebkitTransition: 'all 1s',
    transition: 'all 1s',
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%) ' + (isHover ? 'scale(1.05, 1.05)' : 'scale(1, 1)'),
    opacity: isHover ? 0.2 : 1,
    objectFit: 'contain'
  };

  const ratio = width / (height + 2 * padding);

  const imageStyle = ratio < 1 ? { ...baseImageStyle, height: '100%' } : { ...baseImageStyle, width: '100%' };

  const detailsStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    paddingTop: '100px',
    textAlign: 'center',
    cursor: 'pointer',
    width: '100%',
    WebkitTransition: 'all 1s',
    transition: 'all 1s',
    opacity: isHover ? 1 : 0,
    fontWeight: 'bold'
  };

  const handleClick = () => {
    onClick?.();
  };

  return (
    <div id={'item-'+item.item_id} style={{
      position: 'relative',
      float: 'left',
      padding: `${2 * padding}px ${padding}px 0 ${padding}px`,
      width,
      height: height + 2 * padding
    }}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onClick={handleClick}
  >
      <div style={{ overflow: 'hidden', background: 'white', textAlign: 'center', height: '100%' }}>
        <Img src={getImageSrc(item.images[0], imgSize)} onLoad={onImageLoad} style={imageStyle} useSpinner={true} spinnerColor={template_color} />
      </div>
      <div style={detailsStyle}>
        <p style={{ fontSize: '1.2em' }}>{item.item_name}</p>
        {is_shop_free !=1 && <p style={{ fontSize: '1em' }}>{item.price_label}</p>
        && <p>{displayPrice}</p>}
      </div>
      <TileComments
        item={item}
        comments={itemComments}
        showComments={showComments}
      />
      <Orders
        hover={isHover}
        item={item}
        onAddItem={onAddItem}
        onRemoveItem={onRemoveItem}
        padding={padding}
        template_color={template_color}
        showItemCount={showItemCount}
        useV2={useV2}
        right={padding || '1rem'}
      />
      <Inventory
        item={item}
        template_color={template_color}
        showInventory={showInventory}
      />
    </div>
  );
};

export default Tile;
